<div class="footer-wrap">
  <div class="content">
    <div class="section-1">
      <div class="logo"><img class="brand-logo" [src]="util.logoUrlLight || util.logoUrlDark" [alt]="vars.domainName" /></div>
    </div>
    <div class="section-2">
      <div class="copyright">Copyright © {{currentYear}} Ketto Online Ventures Pvt Ltd.</div>
    </div>
  </div>
</div>